import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Async thunks
export const fetchEndpoints = createAsyncThunk(
  'endpoints/fetchEndpoints',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/endpoints');
      return response.data.endpoints;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch endpoints'
      );
    }
  }
);

export const createEndpoint = createAsyncThunk(
  'endpoints/createEndpoint',
  async (endpointData, { rejectWithValue }) => {
    try {
      const response = await api.post('/endpoints', endpointData);
      return response.data.endpoint;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to create endpoint'
      );
    }
  }
);

export const updateEndpoint = createAsyncThunk(
  'endpoints/updateEndpoint',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/endpoints/${id}`, data);
      return response.data.endpoint;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update endpoint'
      );
    }
  }
);

export const deleteEndpoint = createAsyncThunk(
  'endpoints/deleteEndpoint',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/endpoints/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to delete endpoint'
      );
    }
  }
);

const initialState = {
  endpoints: [],
  loading: false,
  error: null,
};

const endpointsSlice = createSlice({
  name: 'endpoints',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch endpoints
      .addCase(fetchEndpoints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEndpoints.fulfilled, (state, action) => {
        state.loading = false;
        state.endpoints = action.payload;
      })
      .addCase(fetchEndpoints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create endpoint
      .addCase(createEndpoint.fulfilled, (state, action) => {
        state.endpoints.unshift(action.payload);
      })
      // Update endpoint
      .addCase(updateEndpoint.fulfilled, (state, action) => {
        const index = state.endpoints.findIndex(e => e.id === action.payload.id);
        if (index !== -1) {
          state.endpoints[index] = action.payload;
        }
      })
      // Delete endpoint
      .addCase(deleteEndpoint.fulfilled, (state, action) => {
        state.endpoints = state.endpoints.filter(e => e.id !== action.payload);
      });
  },
});

export const { clearError } = endpointsSlice.actions;
export default endpointsSlice.reducer;

